jQuery(document).ready(function($) {
	var mapTimeout = false;

	function changeMapSelection(element) {
		element.closest('.map-wrapper').find('.is-selected').removeClass('is-selected');
		element.addClass('is-selected');
	}

	$(document)
	.on('mouseleave focusout', '.map-wrapper', function(e) {
		$(this).find('.is-selected').removeClass('is-selected');
	})
	.on('mouseenter focus click', '.single-project', function(e) {
		e.preventDefault();
		clearTimeout(mapTimeout);
		mapTimeout = setTimeout(function(element) {
			changeMapSelection(element);
		}, 100, $(this));
	});
});

